<template>
  <a-row class="content-fix" type="flex">
    <spinner v-if="loading" />
    <a-col v-show="!loading" class="height100 flex-1">
      <a-tabs :key="$route.fullPath" class="main-tabs" type="card">
        <a-tab-pane key="content">
          <span slot="tab"> <a-icon type="project" />Содержимое </span>
          <!-- lang tabs -->
          <a-row
            align="middle"
            class="flex-baseline"
            style="margin-bottom: 15px"
          >
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Язык:
            </a-col>
            <a-col :span="12">
              <!-- lang translit tabs -->
              <a-row align="middle" class="flex-baseline flex-wrap">
                <lang-tabs v-model="langTab" class="mb-1x" />
                <a-button
                  v-if="langTab == 'uz' || langTab == 'oz'"
                  @click.stop="translitAction"
                >
                  Перевести копию на
                  {{ langTab == "uz" ? "кирилицу" : "латиницу" }}
                </a-button>
              </a-row>
            </a-col>
          </a-row>

          <!-- title -->
          <a-row
            :class="{ 'form-group--error': emptyTitle }"
            align="middle"
            class="flex-baseline"
          >
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Заголовок:
            </a-col>
            <a-col :span="12" class="sm-mb">
              <a-input
                v-model="form.title[langTab]"
                placeholder="Введите заголовок"
              />
              <div v-if="isTitleNull" class="error-text">
                Введите заголовок на одном из языков.
              </div>
            </a-col>
          </a-row>

          <!-- link -->
          <a-row
            :class="{ 'form-group--error': emptyTitle }"
            align="middle"
            class="flex-baseline"
          >
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Ссылка:
            </a-col>
            <a-col :span="12" class="sm-mb">
              <a-input
                v-model="form.link[langTab]"
                placeholder="Введите заголовок"
              />
              <div v-if="isTitleNull" class="error-text">
                Введите ссылку на одном из языков.
              </div>
            </a-col>
          </a-row>

          <!-- status toggle
                    <a-row style="margin-top: 25px">
                        <a-col :span="6" style="text-align: right; padding-right: 8px;">Статус:</a-col>
                        <a-switch v-model="form.status" />
                    </a-row> -->

          <!-- language availability -->
          <a-row style="margin-top: 25px">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Доступность на языке {{ langTab }}
            </a-col>
            <a-switch v-model="form.language_support[langTab]" />
          </a-row>
        </a-tab-pane>
        <span v-if="form.id" slot="tabBarExtraContent">
          <a-popconfirm
            placement="bottomRight"
            title="Вы действительно хотите удалить данный объявление?"
            @confirm="removeItem"
          >
            <a-button :disabled="pending" style="margin-right: 10px">
              <a-icon type="delete" />Удалить
            </a-button>
          </a-popconfirm>
        </span>
      </a-tabs>

      <a-row class="form-buttons__action" type="flex">
        <a-col :span="6" style="text-align: right; padding-right: 8px" />
        <a-col>
          <a-button :disabled="pending" @click="$router.go(-1)">
            <a-icon type="close" />Отмена
          </a-button>

          <a-button
            :loading="pending"
            style="margin-left: 10px"
            type="primary"
            @click="submitNews"
          >
            <a-icon type="check" />
            {{ form.id ? "Сохранить" : "Добавить" }}
          </a-button>
        </a-col>
      </a-row>
    </a-col>
  </a-row>
</template>

<script>
// import Editor from "@tinymce/tinymce-vue"
// import InputFileItem from "@/components/utils/input-file-item"
import { cloneDeep } from "lodash"

// import VueTagsInput from "@johmun/vue-tags-input"

const newsDefaultFields = () => ({
  title: {
    uz: "",
    oz: "",
    ru: "",
    en: "",
    tj: "",
    kz: ""
  },
  link: {
    uz: "",
    oz: "",
    ru: "",
    en: "",
    tj: "",
    kz: ""
  },
  position: 1,
  status: true,
  language_support: {
    uz: false,
    oz: false,
    ru: false,
    en: false,
    tj: false,
    kz: false
  },
  is_main: false,
  created: null
})

export default {
  name: "Smi",

  //   components: {
  // "image-upload": () => import("@/components/utils/image-upload"),
  // editor: Editor,
  // InputFileItem,
  // VueTagsInput
  //   },
  data: () => ({
    // eslint-disable-next-line no-undef
    langTab: $langPrefix,
    form: {},
    created: null,
    groupCategoryList: [],
    fileList: [],
    pending: false,
    loading: false,

    previewVisible: false,
    previewImage: "",

    tabPane: null,
    main_image: null,
    video_input: {
      file_type: 3,
      file: ""
    },

    video_file: null,

    newsFiles: [],
    document_file: null,
    errors: {
      slug: ""
    },
    tag: "",
    autocompleteItems: [],
    tagTimer: null,
    emptyTitle: false,
    emptyContent: false,

    current_slug: ""
  }),

  computed: {
    isTitleNull() {
      return !!(
        !this.form.title.uz &&
        !this.form.title.oz &&
        !this.form.title.ru &&
        !this.form.title.en
      )
    },
    isLinkNull() {
      return !!(
        !this.form.content.uz &&
        !this.form.content.oz &&
        !this.form.content.ru &&
        !this.form.content.en
      )
    }
  },

  watch: {
    $route: {
      handler: "fetchData",
      immediate: true
    },
    tag: "initItems",
    "form.title": {
      handler(val) {
        try {
          // this.form.language_support[ ru or other lang prefix ] = true if form.title[ lang prefix ] exists or false
          this.$set(
            this.form.language_support,
            this.langTab,
            !!val[this.langTab]
          )
        } catch (error) {
          console.log(error)
        }
      },
      deep: true
    }
  },
  created() {
    this.$set(this, "form", {
      ...newsDefaultFields(),
      category_id: +this.$route.params.cat_id || null,
      created: this.moment(new Date(), "DD-MM-YYYY")
    })

    //   this.$store.dispatch("tags/fetch");
  },
  mounted() {
    this.$on("update:slug", this.onSlugChange)
  },
  beforeDestroy() {
    // fields empty fix
    this.$set(this, "form", { ...newsDefaultFields() })
  },

  methods: {
    async removeItem() {
      try {
        const r = await this.$store.dispatch(
          "smi/deleteItemAction",
          this.form.id
        )
        if (r) {
          this.$message.success("объявление успешно удалена")
          this.$router.go(-1)
        }
      } catch (err) {
        console.log(err)
      }
    },
    translitAction() {
      try {
        const from = this.langTab,
          to = this.langTab == "uz" ? "oz" : "uz",
          methodName = this.langTab == "uz" ? "toKirill" : "toLatin"

        if (this.form.title[from]) {
          this.form.title[to] = this[methodName](this.form.title[from])
        }

        if (this.form.content[from]) {
          this.form.content[to] = this[methodName](this.form.content[from])
        }

        // turn on translit target language_support
        this.$set(this.form.language_support, to, true)
      } catch (error) {
        console.log("translitAction error", error)
      }
    },
    update(newTags) {
      this.autocompleteItems = []
      this.form.tags = newTags
    },
    initItems() {
      // chips, tags fetcher function

      if (this.tag.length < 2) {
        return
      }

      clearTimeout(this.tagTimer)
      this.tagTimer = setTimeout(async () => {
        try {
          const data = await this.$store.dispatch("tags/fetch")

          if (data && data.length) {
            this.autocompleteItems =
              data.map((item) => ({
                ...item,
                text: item.name
              })) || []
          }
        } catch (e) {
          console.log("initItems", e)
        }
      }, 800)
    },
    handleVideoInput(e) {
      if (e.target.files && e.target.files[0]) {
        this.video_file = e.target.files[0]
      }

      this.$refs.videoRef.value = null
    },
    handeDocumentInput(e) {
      if (e.target.files && e.target.files[0]) {
        this.document_file = e.target.files[0]
      }
    },

    check2Null(arg) {
      // console.log("check2Null", r);

      return Object.values(arg).some((item) => !item)
    },
    async submitNews() {
      if (this.check2Null(this.form.title)) {
        this.emptyTitle = true
        this.$message.error("Заголовок обязателен к заполнению")
        return
      }
      if (this.check2Null(this.form.link)) {
        this.emptyTitle = true
        this.$message.error("Ссылка обязателена к заполнению")
        return
      }

      // do your submit logic here
      this.pending = true

      let newData = cloneDeep(this.form)

      newData = {
        ...newData,
        //   title: JSON.stringify(newData.title),
        //   link: JSON.stringify(newData.link),
        //   content: JSON.stringify(newData.content),
        created: this.moment(newData.created)
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
      }

      // return

      const createOrUpdate = {
        url:
          this.form && this.form.id
            ? "/smi/update/" + this.form.id
            : "/smi/create",
        method: this.form && this.form.id ? "put" : "post",
        data: newData
      }

      // console.log(createOrUpdate);

      this.$api[createOrUpdate.method](
        createOrUpdate.url,
        createOrUpdate.data,
        { timeout: 0 }
      )
        .then((res) => {
          if (res && res.status >= 200 && res.data && res.data.id) {
            if (res.data.id) {
              const { id } = res.data

              this.$set(this, "form", { ...this.form, id })
              this.$message.success("Пост создан успешно")
              this.$router.go(-1)

              // upload after post done
            }
          } else {
            this.$message.error(res.status)
          }
          this.pending = false
        })
        .catch((err) => {
          console.log(err)
          this.pending = false
        })
    },
    async fetchData() {
      this.loading = true
      if (isNaN(this.$route.params.id)) {
        this.loading = false
        return
      }

      this.$api
        .get("/smi/get/" + this.$route.params.id)
        .then(async (res) => {
          if (res && res.data) {
            // skip non important keys
            // eslint-disable-next-line no-unused-vars
            const { category, created, updated, views, ...data } = res.data

            this.$set(this, "form", {
              ...this.form,
              ...data,
              // title: JSON.parse(data.title),
              // link: JSON.parse(data.link),
              created: this.moment(created),
              language_support: data.language_support
            })
          }
          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.$message.error(err.responce)
          this.loading = false
        })
    }
  }
}
</script>
